import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { BezoekRij } from "@/components/bezoeken/BezoekRij";
import { BezoekInhoud } from "@/components/bezoeken/BezoekInhoud";
import { magBezoekVastleggen } from "@/components/bezoeken/bezoekUtils";

// v17 D: bezoeken van de laatste 12 weken in het dossier; tikken opent alleen lezen.
export const DossierBezoeken = ({ d, onChanged }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(null);
  const terug = async (b) => {
    try { await api.post(`/bezoeken/${b.id}/terugzetten`); toast.success("Bezoek teruggezet"); onChanged(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Terugzetten mislukt"); }
  };
  const weg = d.bezoekenVerwijderd || [];
  return (
    <section data-testid="dossier-bezoeken" className="bg-white border border-zinc-200 rounded-[10px]">
      <header className="px-4 py-2.5 border-b border-zinc-200 flex items-center gap-2">
        <h3 className="font-heading font-black uppercase text-xs tracking-wider text-zinc-900">Bezoeken</h3>
        <span className="text-xs text-zinc-400">laatste 12 weken</span>
        {magBezoekVastleggen(user) && (
          <button type="button" data-testid="dossier-bezoek-vastleggen" onClick={() => navigate(`/bezoeken?nieuw=${encodeURIComponent(d.locatie)}`)}
            className="ml-auto min-h-[44px] inline-flex items-center gap-1 px-2.5 rounded-md bg-blue-600 text-white text-xs font-semibold hover:bg-blue-700"><Plus className="h-3.5 w-3.5" />Bezoek vastleggen</button>
        )}
      </header>
      {d.bezoeken.length === 0 ? <p className="px-4 py-3 text-sm text-zinc-400 italic">Nog geen bezoek vastgelegd.</p> : (
        <div className="divide-y divide-zinc-200">{d.bezoeken.map((b) => <BezoekRij key={b.id} b={b} zonderLocatie onOpen={setOpen} />)}</div>
      )}
      {weg.length > 0 && (
        <div data-testid="dossier-bezoeken-verwijderd" className="border-t border-zinc-200 px-4 py-2 space-y-1">
          <div className="text-[10px] font-bold uppercase tracking-wider text-zinc-400">Verwijderd</div>
          {weg.map((b) => (
            <div key={b.id} className="flex items-center gap-2 text-sm text-zinc-500">
              <span className="flex-1">{b.datumLabel} · {b.omNaam}</span>
              <button type="button" data-testid={`dossier-bezoek-terugzetten-${b.id}`} onClick={() => terug(b)} className="min-h-[44px] px-3 rounded-md border border-zinc-300 text-xs font-semibold hover:bg-zinc-50">Terugzetten</button>
            </div>
          ))}
        </div>
      )}
      <Dialog open={!!open} onOpenChange={(o) => { if (!o) setOpen(null); }}>
        <DialogContent data-testid="dossier-bezoek-dialog" className="max-w-2xl max-h-[90vh] overflow-y-auto bg-zinc-50">
          <DialogTitle className="sr-only">Bezoek</DialogTitle>
          <DialogDescription className="sr-only">Het bezoek, alleen lezen</DialogDescription>
          {open && <BezoekInhoud id={open.id} alleenLezen />}
        </DialogContent>
      </Dialog>
    </section>
  );
};
